import { render, staticRenderFns } from "./VisitsPanel.vue?vue&type=template&id=1d90a4ce&"
import script from "./VisitsPanel.vue?vue&type=script&lang=js&"
export * from "./VisitsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d90a4ce')) {
      api.createRecord('1d90a4ce', component.options)
    } else {
      api.reload('1d90a4ce', component.options)
    }
    module.hot.accept("./VisitsPanel.vue?vue&type=template&id=1d90a4ce&", function () {
      api.rerender('1d90a4ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/VisitsPanel.vue"
export default component.exports